export enum UserPermissionType {
    Yes = 'yes',
    Disabled = 'disabled',
    No = 'no',
}